import { useEffect, useMemo, useRef, useState } from 'react'
import { LinearProgress } from '@mui/material'
import { ICONE, WizardSincronizzatoConRotta, BaseFeedbackConIcona, BaseContenutoConProgress, BaseGridLayout } from '@lucan/base-ui'
import { OPERAZIONI, useVerbale } from 'configuration/ConfigurazioneApi'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import { DATICONDUCENTE_VERBALE } from 'configuration/datiConducente'
import { useDatiConducenteContext } from 'context/DatiConducenteProvider'
import useLogout from 'hook/useLogout'
import { useRichiestaServerLogged } from 'hook/useRichiestaServerLogged'
import ConfigManager from 'components/config/ConfigManager'
import TitoloTab from 'components/ui/TitoloTab'
import BreadcrumbsDatiConducente from 'components/ui/datiConducente/BreadcrumbsDatiConducente'
import Titolo from 'components/ui/Titolo'
import Testo from 'components/ui/Testo'
import useSchermoStretto from 'hook/useSchermoStretto'
import DatiConducenteContenitore from '../DatiConducenteContenitore'
import { calcolaStatoDatiConducenteVerbale, STATO_DATI_CONDUCENTE_VERBALE } from '../utilDatiConducente'
import useStepDatiConducente from './useStepDatiConducente'
import DecurtazionePunti from './DecurtazionePunti'
import Informativa from './Informativa'
import ListaVerbali from './ListaVerbali'
import Riepilogo from './Riepilogo'

const CFG = DATICONDUCENTE_VERBALE

const CHIAVI_TABS = {
  INFORMATIVA: 'informativa',
  LISTA_VERBALI: 'listaVerbali',
  DATI_VERBALE: 'datiVerbale',
  DATI_DECURTAZIONE_PUNTI: 'datiDecurtazionePunti',
}
Verbale.CHIAVI_TABS = CHIAVI_TABS

export default function Verbale() {
  return (
    <ConfigManager elenchiConfig={[ELENCHI.CFG_DATICONDUCENTE_VERBALE]}>
      {propsConfig => <VerbaleInterno {...propsConfig} />}
    </ConfigManager>
  )
}



function VerbaleInterno(props) {
  const { val } = props

  const [messaggioErrore, setMessaggioErrore] = useState(null)
  const [datiPersonali, setDatiPersonali] = useState(null)
  const [rispostaDatiPersonaliOttenuta, setRispostaDatiPersonaliOttenuta] = useState(false)

  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServerLogged()

  useEffect(() => {
    async function getDatiPersonaliSeCiSono() {
      const { ok, data } = await inviaOperazione(OPERAZIONI.DATI_VERBALE_EXTRA)
      if (ok) {
        if (data.esito) setDatiPersonali(data.data)
        setRispostaDatiPersonaliOttenuta(true)
      }
    }
    getDatiPersonaliSeCiSono()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { BottoneLogout } = useLogout({
    testoBottone: val(CFG.BOTTONI_ESCI_DAL_VERBALE)
  })

  return (
    <DatiConducenteContenitore>
      <BaseGridLayout justifySpaceBetween alignCenter>
        <BreadcrumbsDatiConducente conf={val(CFG.BREADCRUMBS, {}, true)} />
        {BottoneLogout}
      </BaseGridLayout>

      {ScatolaMessaggi}
      {messaggioErrore && <BaseFeedbackConIcona.Errore messaggio={messaggioErrore} />}

      <BaseContenutoConProgress inAttesa={inAttesaDelServer}>
        {rispostaDatiPersonaliOttenuta &&
          <VerbaleWizard
            datiPersonali={datiPersonali}
            {...props}
          />
        }
      </BaseContenutoConProgress>
    </DatiConducenteContenitore>
  )
}



function VerbaleWizard(props) {
  const { datiPersonali, val, txt } = props

  const { chiaveVerbale, isModalitaWeb, verbale, salvaVerbale } = useDatiConducenteContext()

  const {
    informativaAccettata,
    setInformativaAccettata,
    chiaveScelta,
    setChiaveScelta,
    datiVerbaleVisti,
    setDatiVerbaleVisti,
  } = useStepDatiConducente({
    codiceFiscale: datiPersonali?.codiceFiscale,
    chiaveVerbale,
  })

  const {
    ScatolaMessaggi,
    getVerbale: getVerbaleFetch,
    inAttesaDelServer
  } = useVerbale({ conCookie: true })

  useEffect(() => {
    async function getVerbale() {
      const { ok, data } = await getVerbaleFetch(chiaveScelta)
      const { esito, messaggio, verbale: verbaleNuovo } = ok ? data : {}
      if (ok && esito) {
        salvaVerbale(verbaleNuovo)
      }
    }

    if (!verbale && chiaveScelta) {
      getVerbale()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chiaveScelta])

  const vaiAlVerbale = (chiave) => {
    setChiaveScelta(chiave)
    setDatiVerbaleVisti(false)
  }

  const {
    logout,
    inAttesaLogout,
    ScatolaMessaggiLogout
  } = useLogout()

  const stato = calcolaStatoDatiConducenteVerbale(verbale)
  const daCompilare = stato === STATO_DATI_CONDUCENTE_VERBALE.MODULO_DA_COMPILARE

  const schermoStretto = useSchermoStretto()

  const refBottoneIndietro = useRef()

  const tabs = useMemo(() => {
    return [
      {
        chiave: CHIAVI_TABS.INFORMATIVA,
        titolo: <TitoloTab Icona={ICONE.NOTIZIA} titolo={txt(CFG.TABS_INFORMATIVA)} />,
        Contenuto: () => (
          <Informativa
            informativaAccettata={informativaAccettata}
            setInformativaAccettata={setInformativaAccettata}
          />
        ),
        propsBottoneIndietro: {
          ...(inAttesaLogout && { inAttesa: true, disabled: true })
        }
      },
      ...(!isModalitaWeb ? [{
        chiave: CHIAVI_TABS.LISTA_VERBALI,
        titolo: <TitoloTab Icona={ICONE.LISTA} titolo={txt(CFG.TABS_LISTA_VERBALI)} />,
        Contenuto: () => (
          <ListaVerbali
            vaiAlVerbale={vaiAlVerbale}
            chiave={chiaveScelta}
          />
        ),
        validate: { condition: () => informativaAccettata },
      }] : []),
      {
        chiave: CHIAVI_TABS.DATI_VERBALE,
        titolo: <TitoloTab Icona={ICONE.CERCA} titolo={txt(CFG.TABS_DATI_VERBALE)} />,
        Contenuto: () => verbale && (
          <DatiVerbale
            chiaveVerbale={chiaveScelta}
            verbale={verbale}
            setDatiVerbaleVisti={setDatiVerbaleVisti}
          />
        ),
        validate: { condition: () => informativaAccettata && chiaveScelta },
      },
      {
        chiave: CHIAVI_TABS.DATI_DECURTAZIONE_PUNTI,
        titolo: <TitoloTab Icona={ICONE.PADDING} titolo={txt(CFG.TABS_DATI_DECURTAZIONE_PUNTI)} />,
        Contenuto: () => verbale && (
          <DecurtazionePunti
            verbale={verbale}
            chiaveVerbale={chiaveScelta}
            propsWizard={{
              paramsRottaBase: { tab: CHIAVI_TABS.DATI_DECURTAZIONE_PUNTI },
              onClickBottoneIndietroPrimaTab: () => refBottoneIndietro.current.click(),
              labelBottoneAvanti: val(CFG.BOTTONI_AVANTI),
              labelBottoneIndietro: val(CFG.BOTTONI_INDIETRO),
            }}
          />
        ),
        validate: { condition: () => informativaAccettata && chiaveScelta && datiVerbaleVisti && daCompilare },
        propsBottoneIndietro: { sx: { display: 'none' }, inputRef: refBottoneIndietro },
      },
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [informativaAccettata, verbale, datiVerbaleVisti, chiaveScelta, isModalitaWeb, inAttesaLogout, daCompilare])

  return (
    <>
      <Titolo>{txt(CFG.TITOLO)}</Titolo>
      <Testo sx={{ mb: 3 }}>{txt(CFG.SOTTOTITOLO)}</Testo>

      {inAttesaDelServer && <LinearProgress />}

      <WizardSincronizzatoConRotta
        smallMode='sm'
        tabs={tabs}
        chiaveRottaBase={CHIAVI_ROUTES.DATI_CONDUCENTE_VERBALE}
        onClickBottoneIndietroPrimaTab={logout}
        labelBottoneAvanti={val(CFG.BOTTONI_AVANTI)}
        labelBottoneIndietro={val(CFG.BOTTONI_INDIETRO)}
        {...(schermoStretto && { orientation: 'vertical', noPaddingX: true })}
      />

      {ScatolaMessaggi}
      {ScatolaMessaggiLogout}
    </>
  )
}



function DatiVerbale(props) {
  const { chiaveVerbale, verbale, setDatiVerbaleVisti } = props

  useEffect(() => {
    setDatiVerbaleVisti(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Riepilogo
      chiaveVerbale={chiaveVerbale}
      verbale={verbale}
    />
  )
}